/* eslint-disable @next/next/no-img-element */
import { Box, Paper, Typography } from "@mui/material";
import Link from "next/link";
import React from "react";
import Hours from "../info/hours";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import { alpha } from "@mui/material";

const Intro: React.FC = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  return (
    <>
      <Box
        sx={(theme) => ({
          height: "75vh",
          backgroundImage: "url('/img/landing.webp')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          position: "relative",
          [theme.breakpoints.down("sm")]: {
            height: "60vh",
          },
        })}
      >
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(0,0,0,.5)",
            zIndex: 1,
          }}
        />
        <Box
          sx={{
            display: "flex",
            width: "100%",
            height: "100%",
            zIndex: 2,
            position: "relative",
          }}
        >
          <Box
            sx={() => ({
              display: "flex",
              height: "100%",
              flexGrow: 1.3,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            })}
          >
            <img
              src="/img/pivovar-logo.svg"
              height={isMobile ? 200 : 256}
              alt="Logo Pivovar Čáslav"
              loading="lazy"
            />
            <Typography
              color="white"
              component="h1"
              variant="h3"
              sx={(theme) => ({
                fontWeight: "bold",
                marginTop: theme.spacing(4),
                [theme.breakpoints.down("md")]: {
                  fontSize: 28,
                  paddingX: theme.spacing(2),
                },
              })}
            >
              Pivovarská restaurace v&nbsp;Čáslavi
            </Typography>
          </Box>
          <Box
            sx={(theme) => ({
              display: "flex",
              height: "100%",
              flexGrow: 1,
              flexDirection: "column",
              justifyContent: "center",
              alignItems: "center",
              [theme.breakpoints.down("sm")]: { display: "none" },
            })}
          >
            <Paper
              sx={(theme) => ({
                padding: theme.spacing(4),
                minWidth: "60%",
                backgroundColor:
                  theme.palette.mode === "light"
                    ? "rgba(255, 255, 255, 0.8)"
                    : alpha(theme.palette.background.paper, 0.8),
              })}
            >
              <Hours />
            </Paper>
          </Box>
        </Box>
      </Box>
      <Paper
        sx={(theme) => ({
          margin: theme.spacing(2),
          padding: theme.spacing(2),
          [theme.breakpoints.up("sm")]: { display: "none" },
        })}
      >
        <Hours />
      </Paper>
    </>
  );
};

export default Intro;
